import { api } from './api';

export const fetchAccountStatements = (params, options) => {
  return api.get(`/account_statement`, params, options);
};

export const fetchAccountStatementById = (id) => {
  return api.get(`/account_statement/${id}`);
};

export const processAccountStatementBalanceById = (id) => {
  return api.post(`/account_statement/${id}/process`);
};

export const processAccountStatementBalanceBulk = (payload) => {
  return api.post(`/account_statement/bulk/process`, payload);
};
